import { useState } from "react";
import { useNavigate } from "react-router-dom";
import fetcher from "../../../helper/fetcher";
import { validateEmail } from "../../../validations/validate";
import { useSnackbar } from "../../../context/SnackBarContext";
import CrmRegistrationUI from "../../../component/CrmUI/CrmIRegistrationUI";
import { useCrm } from "../../../context/CrmContext";
import axios from "axios";
import { apiUrl } from "../../../utils/utils";

const CrmRegistration = () => {
    const { showSuccess, showError } = useSnackbar();
    const navigate = useNavigate();
    const { setIsAuthenticated, setUser: Log, setRoles } = useCrm();

    const [user, setUser] = useState({
        userName: "",
        telephone: "",
        email: "",
        role: "",
        companyName: "",
        state: "",
        gstin: "",
        address: "",
        password: "",
        confirmPassword: "",
        profile_image: "",
        isLoading: false,
    });

    const updateState = (data) => {
        setUser((prevState) => {
            const newState = { ...prevState, ...data };
            return newState;
        });
    };

    const validatePassword = (password) => {
        const requirements = [
            {
                test: (p) => p.length >= 6,
                message: "Password must contain at least 6 characters",
            },
            {
                test: (p) => /[0-9]/.test(p),
                message: "Password must contain at least one number",
            },
            {
                test: (p) => /[a-z]/.test(p),
                message: "Password must contain one lower case character",
            },
            {
                test: (p) => /[A-Z]/.test(p),
                message: "Password must contain one upper case character",
            },
            {
                test: (p) => /[ `!@#$%^&*()_+\-=\[\]{};':\"\\|,.<>\/?~]/.test(p),
                message: "Password must contain one special character",
            },
        ];

        for (const { test, message } of requirements) {
            if (!test(password)) {
                return showError(message);
            }
        }
        return true;
    };

    const register = async (e) => {
        e.preventDefault();

        // validation checks
        if (!user.userName) return showError("Name is required");
        if (!user.telephone) return showError("Phone number is required");
        if (!validateEmail(user.email)) return showError("Enter valid email");
        if (!user.role) return showError("Role is required");
        if (!user.companyName) return showError("Company name is required");
        if (!user.gstin) return showError("GST number is required");
        if (!user.address) return showError("Business address is required");
        if (!validatePassword(user.password)) return;
        if (user.password !== user.confirmPassword)
            return showError("Passwords do not match");

        updateState({ isLoading: true });

        const formData = new FormData();
        formData.append("name", user.userName);
        formData.append("telephone", user.telephone);
        formData.append("email", user.email);
        formData.append("companyName", user.companyName);
        formData.append("gst", user.gstin);
        formData.append("address", user.address);
        formData.append("password", user.password);
        formData.append("profile_image", user.profile_image);
        formData.append("state", user.state);
        formData.append("role", user.role);

        axios.post(`${apiUrl}crm/auth/register`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then((res) => {
                console.log("Register response ====>>>", res.data.data);
                Log(res.data.data);
                setRoles([res.data.data.role]);
                localStorage.setItem("token", JSON.stringify(res.data?.jwt));
                showSuccess("Registered successfully!");
                console.log("User details:", res.data.data);
                console.log("Token stored:", localStorage.getItem("token"));
                navigate("/crm/login");
                setIsAuthenticated(true);
            })
            .catch((error) => {
                showError(error.response?.data?.message || "Internal server Error");
            })
            .finally(() => {
                updateState({ isLoading: false });
            });
    };

    return (
        <CrmRegistrationUI
            login={register}
            updateState={updateState}
            user={user}
            isLoading={user.isLoading}
        />
    );
};

export default CrmRegistration;
